var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"brand",class:_vm.size},[_c('img',{staticClass:"brand-logo",attrs:{"src":_vm.src,"alt":`${_vm.company.name}（${_vm.company.brandEn}）`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }